import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  OutlinedInput,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import moment, { now } from "moment";
import { LoadingButton } from "@mui/lab";
import { MuiTelInput, matchIsValidTel } from "mui-tel-input";
import { useLocation, useNavigate } from "react-router-dom";
import PostHooks from "../../../../Api/PostHooks";
import AlertComponent from "../../../../Components/AlertComponent";
import { useSelector } from "react-redux";

const AddKinForm = ({ _user, onClose, onSuccess }) => {
  const {
    watch,
    control,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();
  const location = useLocation();
  const loggedInUser = useSelector((state) => state.auth.user);

  const now = new Date();

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });
  const [user, setUser] = useState(
    _user || location?.state?.user || loggedInUser
  );

  const msisdn = watch("msisdn");

  const [loading, response, request] = PostHooks();

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const onSubmit = async (e) => {
    try {
      let formData = {
        first_name: e.first_name,
        surname: e.surname,
        other_names: e.other_names,
        company_name: "",
        state: "",
        residential_address: "",
        postal_address: "",
        id_number: e.identification_number,
        passport_number: "",
        county: "",
        subcounty: "",
        ward: "",
        village: "",
        serial_no: "",
        msisdn: msisdn.replace("+", ""),
        document_registration_date: moment(now).format("YYYY-MM-DD"),
        document_expiry_date: moment(now).format("YYYY-MM-DD"),
        name: e.first_name,
        document_number: e.identification_number,
        description: "Customer registration",
        registry_file_number: "",
        role: "next_kin",
        channel_name: "mobile_number",
        member_entity_id: user?.id,
        username: e.identification_number,
        allocation: e.allocation,
      };

      let props = {
        url: "/user",
        body: formData,
      };

      const addResp = await request(props);

      if (addResp && addResp.status === 200 && addResp.data.StatusCode === 0) {
        setSnackbar({
          open: true,
          severity: "success",
          message: "Next Kin added successfully!",
        });
        setTimeout(() => {
          onClose();
          onSuccess();
        }, 1000);
      } else {
        const errorMessage =
          addResp?.data?.StatusMessage ??
          addResp?.data?.message ??
          addResp.message ??
          "An unexpected error occurred. Please try again.";

        setSnackbar({
          open: true,
          severity: "error",
          message: errorMessage,
        });
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.StatusMessage ??
        error.response?.data?.message ??
        error.message ??
        "An unexpected error occurred. Please try again.";

      setSnackbar({
        open: true,
        severity: "error",
        message: errorMessage,
      });
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} id="form">
      <AlertComponent
        open={snackbar.open}
        handleSnackbar={handleSnackbarClose}
        severity={{ severity: snackbar.severity, message: snackbar.message }}
      />

      <Grid
        container
        rowSpacing={3}
        sx={{ my: "10px" }}
        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
      >
        <Grid
          item
          xs={6}
          md={4}
          sx={{
            paddingTop: "20px",
          }}
        >
          <FormControl fullWidth error={!!errors.first_name}>
            <InputLabel htmlFor="first_name">First name</InputLabel>
            <OutlinedInput
              id="first_name"
              {...register("first_name", { required: true })}
              label="First name"
              xs={12}
              variant="filled"
            />
            {errors.first_name && <FormHelperText>Required</FormHelperText>}
          </FormControl>
        </Grid>

        <Grid
          item
          xs={6}
          md={4}
          sx={{
            paddingTop: "20px",
          }}
        >
          <FormControl fullWidth error={!!errors.surname}>
            <InputLabel htmlFor="surname">Surname</InputLabel>
            <OutlinedInput
              id="surname"
              {...register("surname", { required: false })}
              label="Surname"
              xs={12}
              variant="filled"
            />
            {errors.surname && <FormHelperText>Required</FormHelperText>}
          </FormControl>
        </Grid>

        <Grid
          item
          xs={12}
          md={4}
          lg={4}
          sx={{
            paddingTop: "20px",
          }}
        >
          <FormControl fullWidth error={!!errors.other_names}>
            <InputLabel htmlFor="other_names">Other name</InputLabel>
            <OutlinedInput
              variant="filled"
              id="other_names"
              {...register("other_names", { required: true })}
              label="Other name"
              xs={12}
            />
            {errors.other_names && <FormHelperText>Required</FormHelperText>}
          </FormControl>
        </Grid>

        <Grid
          item
          xs={12}
          md={6}
          lg={6}
          sx={{
            paddingTop: "20px",
          }}
        >
          <FormControl fullWidth error={!!errors.identification_number}>
            <InputLabel>National ID Number/ Passport Number</InputLabel>
            <OutlinedInput
              variant="filled"
              id="identification_number"
              {...register("identification_number", {
                required: true,
                maxLength: 10,
                minLength: 7,
              })}
              label="National ID Number/ Passport Number"
              xs={12}
              type="number"
              inputProps={{ step: "any", min: 0 }}
            />
            {errors.identification_number && (
              <FormHelperText>
                Enter your National ID Number/ Passport Number
              </FormHelperText>
            )}
          </FormControl>
        </Grid>

        {/* 
        <Grid
          item
          xs={12}
          md={12}
          lg={12}
          sx={{
            paddingTop: "20px",
          }}
        >
          <FormControl fullWidth error={!!errors.username}>
            <InputLabel htmlFor="username">Username</InputLabel>
            <OutlinedInput
              variant="filled"
              id="username"
              {...register("username", { required: true })}
              label="Username"
              xs={12}
            />
            {errors.username && <FormHelperText>Required</FormHelperText>}
          </FormControl>
        </Grid> */}

        <Grid
          item
          xs={12}
          md={6}
          lg={6}
          sx={{
            paddingTop: "20px",
          }}
        >
          <Controller
            name="msisdn"
            control={control}
            rules={{
              validate: (value) => matchIsValidTel(value),
            }}
            defaultValue={"+254"}
            render={({ field, fieldState }) => (
              <MuiTelInput
                {...field}
                fullWidth
                defaultCountry="KE"
                onlyCountries={["KE"]}
                helperText={fieldState.invalid ? "Invalid mobile number!" : ""}
                error={fieldState.error}
                value={field.value || ""}
                disableFormatting
              />
            )}
          />
        </Grid>

        <Grid
          item
          xs={12}
          md={12}
          lg={12}
          sx={{
            paddingTop: "20px",
          }}
        >
          <FormControl fullWidth error={!!errors.allocation}>
            <InputLabel htmlFor="allocation">Allocation (0-100%)</InputLabel>
            <OutlinedInput
              variant="filled"
              id="allocation"
              {...register("allocation")}
              label="Allocation (0-100%)"
              type="number"
              defaultValue={100}
              inputProps={{ step: "any", min: 0 }}
            />

            <FormHelperText>
              Percentage Allocation of Inheritance
            </FormHelperText>

            {errors.allocation && <FormHelperText>Required</FormHelperText>}
          </FormControl>
        </Grid>
      </Grid>

      <Box
        sx={{
          pt: "20px",
          gap: 2,
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <Button
          size="large"
          type="reset"
          variant="outlined"
          onClick={() => onClose()}
        >
          cancel
        </Button>
        <LoadingButton
          variant="contained"
          // sx={{ ml: "10px" }}
          size="large"
          type="submit"
          loading={loading}
        >
          Add
        </LoadingButton>
      </Box>
    </form>
  );
};

export default AddKinForm;
